import { IStyles } from '@interfaces/styles';
import { colors } from '@constants/colors';

export const useStyles = (): IStyles => {
  return {
    menu: {
      color: colors.white,
      padding: 0,
      gap: 0.5,

      '& .MuiDivider-root': {
        my: 1.5,
        backgroundColor: '#FFFFFF4D',
      },
    },
    link: {
      paddingX: 0,
      paddingY: 0.5,

      '& .MuiListItemIcon-root': {
        minWidth: 28,
      },
    },
    linkText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '& .MuiListItemText-primary': {
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: '0.02em',
      },
    },
  };
};
